import { object } from 'prop-types'
import React, { createContext, useState } from 'react'

export const PageNumberContext = createContext({})

const PageNumberProvider = ({ children }) => {
  const [peerStoriesPageNumber, setPeerStoriesPageNumber] = useState(1)
  const [browseResourcesPageNumber, setBrowseResourcesPageNumber] = useState(1)

  return (
    <PageNumberContext.Provider
      value={{
        peerStoriesPageNumber,
        setPeerStoriesPageNumber,
        browseResourcesPageNumber,
        setBrowseResourcesPageNumber,
      }}
    >
      {children}
    </PageNumberContext.Provider>
  )
}

PageNumberProvider.propTypes = {
  children: object.isRequired,
}

export default PageNumberProvider
